import { faker } from '@faker-js/faker'

import { UserServiceOfferInHospitalCategories } from '../../contracts/service-offer/UserServiceOfferInHospitalCategory'
import { asBuilder } from '../asBuilder'

export const getUserServiceOfferInHospitalTreatmentCategory = asBuilder((): UserServiceOfferInHospitalCategories => {
  return {
    totalCount: faker.number.int(),
    categories: faker.helpers.multiple(() => ({
      id: faker.number.int(),
      name: faker.string.uuid(),
      count: faker.number.int(),
    })),
  }
})
